import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = typeof window !== 'undefined' ? localStorage.getItem('pricing_countdown_end') : null;
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      if (remaining > 0) return remaining;
    }
    const end = Date.now() + 24 * 60 * 60 * 1000;
    if (typeof window !== 'undefined') localStorage.setItem('pricing_countdown_end', end.toString());
    return 24 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const cuposPercentage = 71;
  return <section className="w-full bg-[#FFFFFF] py-16 md:py-24" data-id="element-164">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-166">
          <div className="text-center mb-16" data-id="element-167">
            <div className="bg-[#F7F2EA] border border-[#E7DDD2] rounded-3xl p-8 md:p-12 max-w-4xl mx-auto shadow-sm" data-id="element-168">
              <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#3E2B1F] mb-8" data-id="element-169">
                PRECIO DE LANZAMIENTO — OFERTA LIMITADA
              </h2>

              <div className="flex items-center justify-center gap-4 md:gap-8 mb-8" data-id="element-170">
                {[{
                value: pad(hours),
                label: 'HS'
              }, {
                value: pad(minutes),
                label: 'MIN'
              }, {
                value: pad(seconds),
                label: 'SEG'
              }].map((unit, index) => <Fragment key={unit.label} data-id="element-171">
                    {index > 0 && <span className="font-serif text-5xl md:text-7xl font-bold text-[#C96B17] -mt-6 md:-mt-8" data-id="element-172">
                        :
                      </span>}
                    <div className="flex flex-col items-center" data-id="element-173">
                      <motion.span key={unit.value} initial={{
                    scale: 1.05,
                    opacity: 0.8
                  }} animate={{
                    scale: 1,
                    opacity: 1
                  }} transition={{
                    duration: 0.3
                  }} className="font-serif text-6xl md:text-8xl font-bold text-[#C96B17] tabular-nums leading-none" data-id="element-174">
                        {unit.value}
                      </motion.span>
                      <span className="text-sm md:text-base text-[#B66A2C] font-bold mt-2 tracking-widest uppercase" data-id="element-175">
                        {unit.label}
                      </span>
                    </div>
                  </Fragment>)}
              </div>

              <div className="flex items-center justify-center gap-3 text-[#3E2B1F] mb-8" data-id="element-176">
                <p className="text-base md:text-lg font-medium max-w-2xl" data-id="element-177">
                  Este precio no se va a mantener. Una vez que se agoten los
                  cupos de lanzamiento, el precio sube a $58.960 ARS. No vuelve
                  atrás.
                </p>
              </div>

              <div className="max-w-2xl mx-auto bg-white p-6 rounded-2xl border border-[#E7DDD2] shadow-sm" data-id="element-178">
                <div className="flex items-center justify-between mb-3" data-id="element-179">
                  <div className="flex items-center gap-2" data-id="element-180">
                    <span className="w-2.5 h-2.5 rounded-full bg-[#C96B17] animate-pulse" data-id="element-181"></span>
                    <span className="text-base text-[#3E2B1F] font-semibold" data-id="element-182">
                      Cupos al precio de lanzamiento
                    </span>
                  </div>
                  <span className="text-base text-[#B66A2C] font-bold" data-id="element-183">
                    Quedan pocos
                  </span>
                </div>
                <div className="w-full h-4 bg-[#F3ECE2] rounded-full overflow-hidden" data-id="element-184">
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: `${cuposPercentage}%`
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1.5,
                  ease: 'easeOut'
                }} className="h-full rounded-full bg-[#C96B17]" data-id="element-185" />
                </div>
                <p className="text-sm text-[#3E2B1F]/60 mt-3 text-right font-medium" data-id="element-186">
                  {cuposPercentage}% de los cupos ya tomados
                </p>
              </div>
            </div>
          </div>

          <h3 id="elegi-tu-pack" className="font-serif text-3xl md:text-4xl font-bold text-[#3E2B1F] text-center mb-10 scroll-mt-12" data-id="element-187">
            TU ACCESO COMPLETO
          </h3>

          <div className="max-w-3xl mx-auto" data-id="element-188">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="bg-white border border-[#E7DDD2] rounded-3xl p-8 md:p-12 relative shadow-premium" data-id="element-189">
              <h4 className="font-serif text-2xl md:text-3xl font-bold text-[#3E2B1F] mb-2 text-center" data-id="element-190">
                MEGA PACK EMPRENDE MINIDONAS 360
              </h4>
              <p className="text-[#B66A2C] font-semibold mb-6 text-lg text-center" data-id="element-191">
                6 Tomos + 4 Bonos — Masa → Negocio en Pesos
              </p>
              <p className="text-[#3E2B1F]/80 text-base md:text-lg mb-8 text-center max-w-xl mx-auto" data-id="element-192">
                Ideal para cualquier persona que quiera emprender con minidonas
                desde casa, sin experiencia previa
              </p>

              <div className="bg-[#F7F2EA] rounded-2xl p-8 mb-8 text-center border border-[#E7DDD2]" data-id="element-193">
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-194">
                  <span className="text-[#3E2B1F]/50 line-through text-2xl font-medium" data-id="element-195">
                    $58.960
                  </span>
                  <span className="bg-[#3E2B1F] text-white text-sm font-bold px-3 py-1 rounded-full tracking-widest" data-id="element-196">
                    -71% OFF
                  </span>
                </div>
                <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-197">
                  <span className="text-[#C96B17] font-bold text-6xl md:text-7xl font-serif" data-id="element-198">
                    $16.990
                  </span>
                  <span className="text-[#3E2B1F]/60 text-lg font-medium" data-id="element-199">
                    ARS
                  </span>
                </div>
                <p className="text-[#5C8A6D] font-bold text-lg" data-id="element-200">
                  Ahorrás $41.970 hoy
                </p>
              </div>

              <motion.a id="boton-pago" href="https://www.recursohub.com/cart/48199368966336:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="block w-full bg-[#C96B17] hover:bg-[#A95712] text-white font-bold text-xl px-8 py-5 rounded-2xl transition-all duration-300 shadow-premium hover:shadow-premium-hover text-center scroll-mt-24 mb-4" data-id="element-201">
                QUIERO MI MEGA PACK AHORA
              </motion.a>

              <motion.a href="https://wa.me/543516347235?text=Hola!!%20Quiero%20abonar%20el%20Mega%20Pack%20Emprende%20Minidonas%20360%20con%20transferencia%20bancaria%20y%20aprovechar%20el%2015%25%20de%20descuento.%20Gracias!!" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="flex items-center justify-center gap-3 w-full bg-white hover:bg-[#F7F2EA] border-2 border-[#E7DDD2] text-[#3E2B1F] font-bold text-lg px-6 py-4 rounded-2xl transition-all duration-300 text-center" data-id="element-202">
                <svg className="w-5 h-5 text-[#25D366]" viewBox="0 0 24 24" fill="currentColor" data-id="element-203">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" data-id="element-204" />
                </svg>
                Pagar por transferencia — 15% OFF ($14.441)
              </motion.a>

              <div className="mt-6 text-center text-sm text-[#3E2B1F]/60 font-medium leading-relaxed" data-id="element-205">
                Pago 100% seguro · Acceso en 5 minutos · Garantía 7 días
                <br data-id="element-206" />
                Mercado Pago · Tarjeta · Transferencia
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}